import { toast } from '../utils/prompt';
/**
 * 跳转视频号直播
 * @param finderUserName 视频号 id，以“sph”开头的id，可在视频号助手获取
 */
export const openChannelsLive = (finderUserName) => {















};

/**
 * 跳转视频号主页
 * @param finderUserName 视频号 id，以“sph”开头的id，可在视频号助手获取
 */
 export const openChannelsUserProfile = (finderUserName) => {
  wx.openChannelsUserProfile({
    finderUserName,
    success: () => {},
    fail: (e) => {
      console.log(e);
    },
  });
};

/**
 * 预约视频号直播
 * @param finderUserName 视频号 id，以“sph”开头的id，可在视频号助手获取
 */
 export const reserveChannelsLive = (finderUserName, cb) => {
  wx.getChannelsLiveNoticeInfo({
    finderUserName,
    success: (res) => {
      const { noticeId } = res;
      console.log(res);
      wx.reserveChannelsLive({
        noticeId,
        success: (liveres) => {
          cb(liveres.state);
          console.log('liveres', liveres);
        },
        fail: (e) => {
          console.log(e);
        },
      });
    },
    fail: (e) => {
      cb();
      toast('当前暂无直播可预约!');
      console.log(e);
    },
  });
};
